import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { menuPrefixCls } from "@/base/components/menu/Menu.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Menu">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${menuPrefixCls}-horizontal`]: {
      maxHeight: "64px",
      [`.${menuPrefixCls}-title-content`]: {
        textTransform: "uppercase",
      },

      [`.${ICON_PREFIX}`]: {
        verticalAlign: `-0.25em`,
      },
    },
  },
  [`.${menuPrefixCls}-vertical`]: {
    [`&.${menuPrefixCls}-sub`]: {
      paddingInline: "6px !important",
      paddingBlock: "6px !important",
    },
  },
  [`.${ICON_PREFIX}-ellipsis`]: {
    verticalAlign: `-0.25em !important`,
  },
  [`.${menuPrefixCls}-submenu`]: {
    [`.${menuPrefixCls}-item-icon`]: {
      verticalAlign: `-0.25em !important`,
    },
  },
});

export const useMenuStyle = genComponentStyleHook(["Menu", "cso"], (token) => {
  return [genStyle(token)];
});
